import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-json-view',
  templateUrl: './endpoint-json-view.page.html',
  styleUrls: ['./endpoint-json-view.page.scss'],
})
export class EndpointJsonViewPage implements OnInit {
  endpoint: any;
  from: any;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {
    this.endpoint = this.navParams.get('endpoint')
    this.from = this.navParams.get('from')
  }

  goBack() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
  }
}